import { render, staticRenderFns } from "./ModulesHero.vue?vue&type=template&id=2ef8fcc8"
import script from "./ModulesHero.vue?vue&type=script&lang=js"
export * from "./ModulesHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SnippetHero: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetHero.vue').default})
